"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var java_js_dateformat_1 = require("java-js-dateformat");
var F_PlainTime = /** @class */ (function () {
    /** @hidden */
    function F_PlainTime(plainTime) {
        this.plainTime = plainTime;
        this.format = this.format.bind(this);
        this.toIso = this.toIso.bind(this);
    }
    /** @hidden */
    F_PlainTime.prototype._getTemporalPlainTime = function () {
        return this.plainTime;
    };
    F_PlainTime.prototype.format = function (pattern) {
        return java_js_dateformat_1.Formatters.formatLocalTime(this.plainTime.hour, this.plainTime.minute, pattern);
    };
    F_PlainTime.prototype.toIso = function () {
        var timeStr = this.plainTime.toString();
        return timeStr.slice(0, timeStr.lastIndexOf(':'));
    };
    return F_PlainTime;
}());
exports.default = F_PlainTime;
//# sourceMappingURL=F_PlainTime.js.map